import moment from "moment";

export const createDefaultOption = (labelKey, valueKey, array) => {
  return array.map(item => ({
    label: item[labelKey] || "",
    value: item[valueKey] || ""
  }));
};

export const currencyFormate = (number) => {
  if (number) {
    // number = Number(number)?.toFixed(2)
    const formattedNumber =  number.toLocaleString("en-IN", {
      style: "decimal",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const html = `<span style="font-family: sans-serif" ">₹ </span> ${(formattedNumber)}`;

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  } else {
    return "-";
  }
};

export const getStartDate = (date) => {
  return moment(date).format("YYYY-MM-DDT00:00:00.000") + "Z";
};

export const getEndDate = (date) => {
  return moment(date).format("YYYY-MM-DDT23:59:59.000") + "Z";
};

